export default {
  name: "Dashboard",
  path: "/dashboard",
  component: () => import("@/views/Dashboard")
};
